// Marital Statuses
export const NEVER_MARRIED = 'NeverMarried';
export const MARRIED = 'Married';
export const SPOUSE = 'Spouse';
export const SEPARATED = 'Separated';
const ANNULLED = 'Annulled';
const DIVORCED = 'Divorced';
const WIDOWED = 'Widowed';

// Relatives
export const MOTHER = 'Mother';
export const FATHER = 'Father';
export const STEPMOTHER = 'Stepmother';
export const STEPFATHER = 'Stepfather';
const FOSTER_PARENT = 'Fosterparent';
export const CHILD = 'Child';
const STEPCHILD = 'Stepchild';
const BROTHER = 'Brother';
const SISTER = 'Sister';
const STEPBROTHER = 'Stepbrother';
const STEPSISTER = 'Stepsister';
const HALF_BROTHER = 'Half-brother';
const HALF_SISTER = 'Half-sister';
export const FATHER_IN_LAW = 'Father-in-law';
export const MOTHER_IN_LAW = 'Mother-in-law';
const GUARDIAN = 'Guardian';

export const marriedOptions = [MARRIED, SEPARATED];

export const marriedOptionsPvq = [MARRIED, SPOUSE, SEPARATED];

export const previouslyMarriedOptions = [ANNULLED, DIVORCED, WIDOWED];

export const maritalStatusOptions = [NEVER_MARRIED, MARRIED, SEPARATED, ANNULLED, DIVORCED, WIDOWED];

export const maritalStatusOptionsPvq = [NEVER_MARRIED, MARRIED, SPOUSE, SEPARATED, ANNULLED, DIVORCED, WIDOWED];

export const relationshipOptions = ['Neighbor', 'Friend', 'WorkAssociate', 'Schoolmate', 'Other'];

export const immediateFamilyOptions = [
  MOTHER,
  FATHER,
  STEPMOTHER,
  STEPFATHER,
  CHILD,
  STEPCHILD,
  BROTHER,
  SISTER,
  STEPBROTHER,
  STEPSISTER,
  HALF_BROTHER,
  HALF_SISTER,
];

export const immediateAdditionalFamilyOptions = [
  ...immediateFamilyOptions,
  FOSTER_PARENT,
  GUARDIAN,
  FATHER_IN_LAW,
  MOTHER_IN_LAW,
];

export const relativeOptions = [
  MOTHER,
  FATHER,
  STEPMOTHER,
  STEPFATHER,
  FOSTER_PARENT,
  CHILD,
  STEPCHILD,
  BROTHER,
  SISTER,
  STEPBROTHER,
  STEPSISTER,
  HALF_BROTHER,
  HALF_SISTER,
  FATHER_IN_LAW,
  MOTHER_IN_LAW,
  GUARDIAN,
];

export const relativeCitizenshipDocumentationOptions = [
  'FS',
  'DS',
  'NaturalizedAlien',
  'NaturalizedPermanent',
  'NaturalizedCertificate',
  'DerivedAlien',
  'DerivedPermanent',
  'DerivedCertificate',
  'Other',
];

export const relativeResidentDocumentationOptions = [
  'Permanent',
  'Employment',
  'Arrival',
  'Visa',
  'F1',
  'J1',
  'Other',
];

// PVQ Dropdown values
export const relationshipMarriageStatusOptions = [
  'Single (never in a civil marriage, civil union, domestic partnership, or common law marriage)',
  'In a civil marriage, civil union, domestic partnership, or common law marriage',
  'In a committed, spouse-like relationship',
  'Legally separated',
  'Annulled',
  'Divorced/Dissolved',
  'Widowed',
];

// PVQ Dropdown values
export const otherNamesOptions = [
  'Name prior to marriage',
  'Former married name',
  'Nickname',
  'Alias',
  'Former legal name',
  'Other',
];

// PVQ Dropdown values
export const relativeTypes = [
  'Parent',
  'Stepparent',
  'Foster parent',
  'Child (including adopted/foster)',
  'Stepchild',
  'Sibling',
  'Step Sibling',
  'Half Sibling',
  'Parent-in-law',
  'Guardian',
];

// PVQ Radio values
export const residencyStatus = [
  'ResidencyPermanent',
  'ResidencyAsylee',
  'ResidencyNonimmigrant',
  'ResidencyTPS',
  'ResidencyDACA',
  'Other',
];

// PVQ Checkbox values
export const methodsOfContact = [
  'In-person',
  'Telephone',
  'Electronic means (for example, email, texting, chat rooms)',
  'Written correspondence',
  'Other',
  'None',
];

// PVQ Radio values
export const frequencyOfContact = [
  'Daily',
  'Weekly',
  'Monthly',
  'Quarterly',
  'Annually',
  'Other',
];

// PVQ Radio values
export const relativeEmployerNonUS = [
  'Military',
  'Security',
  'Intelligence',
  'Government',
  'Defense',
  'Foreign',
  'Not Associated',
];
